import { render } from '$lib/core/entry';

(function () {
    let div = document.querySelector("body div");
    render(div, window._init_data_);
})();
